import type { StateType } from '../../lib/types/state-type';
import type { FurnhomeCommunication } from '@dh-software/furnhome-communication';

// Der Wechsel laeuft ueber den OAuth-Server und endet mit einem kompletten Seitenaufbau: jedes
// Modul startet danach frisch an der neuen Kundennummer, auch ein schon besuchtes.
export function switchStore(state: StateType, parameters: unknown[], communication: FurnhomeCommunication): StateType {
  const customerNumber = String(parameters[0] ?? '');

  if (!customerNumber || customerNumber === state.customerNo) {
    return state;
  }

  window.location.href = communication.getStoreSwitchUrl(customerNumber, window.location.href);
  return { ...state, page: 'loading' };
}
